var map = {
	"./1/top-right-1.png": "7ZgG",
	"./2/top-right-1.png": "Fd+h",
	"./3/top-right-1.png": "wXtx",
	"./4/top-right-1.png": "dL6z",
	"./5/top-right-1.png": "+GuL",
	"./6/top-right-1.png": "FMD4",
	"./7/top-right-1.png": "Z6bS",
	"./8/top-right-1.png": "UMoQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Qsth";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*\/top\-right\-1\.png$
// module id = Qsth
// module chunks = 1